var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"footer"},[_c('p',[_vm._v("hello@wdomilk.com")]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("鲁ICP备19006398号-3")])])])
}]

export { render, staticRenderFns }